import {
  PORTAL_LEAD_WEBHOOK_FIELDS,
  portalLeadWebhookFieldExample,
} from '@/constants/portalLeadWebhookFields'

export type PortalLeadVariableMappingEntry = {
  position: number
  source_type: 'portal_field'
  source_key: string
  fallback_text?: string
}

type LegacyPortalMappingEntry = {
  position: number
  field_key?: string
  source_type?: string
  source_key?: string
  fallback_text?: string
}

export function normalizePortalMappingFromApi(
  mapping: LegacyPortalMappingEntry[] | undefined,
): PortalLeadVariableMappingEntry[] {
  return (mapping ?? []).map((entry) => ({
    position: entry.position,
    source_type: 'portal_field',
    source_key: entry.source_key || entry.field_key || '',
    ...(entry.fallback_text ? { fallback_text: entry.fallback_text } : {}),
  }))
}

export function buildPortalVariableMapping(
  count: number,
  previous: PortalLeadVariableMappingEntry[] = [],
): PortalLeadVariableMappingEntry[] {
  return Array.from({ length: count }, (_, index) => {
    const position = index + 1
    const existing = previous.find((item) => item.position === position)
    if (existing) {
      return { ...existing, position, source_type: 'portal_field' }
    }
    return { position, source_type: 'portal_field', source_key: '' }
  })
}

export function normalizePortalMappingForApi(
  mapping: PortalLeadVariableMappingEntry[],
): PortalLeadVariableMappingEntry[] {
  return mapping
    .filter((entry) => entry.source_key)
    .map((entry) => ({
      position: entry.position,
      source_type: 'portal_field' as const,
      source_key: entry.source_key,
      ...(entry.fallback_text ? { fallback_text: entry.fallback_text } : {}),
    }))
}

export function previewPortalTemplateBody(
  bodyText: string,
  mapping: PortalLeadVariableMappingEntry[],
): { preview: string; missingPositions: number[] } {
  const missingPositions: number[] = []
  const preview = bodyText.replace(/\{\{(\d+)\}\}/g, (_, rawPosition) => {
    const position = Number(rawPosition)
    const entry = mapping.find((item) => item.position === position)
    if (!entry?.source_key) {
      missingPositions.push(position)
      return `{{${position}}}`
    }
    const example = portalLeadWebhookFieldExample(entry.source_key)
    if (example) return example
    const field = PORTAL_LEAD_WEBHOOK_FIELDS.find((item) => item.key === entry.source_key)
    return field?.label || entry.source_key
  })
  return { preview, missingPositions: [...new Set(missingPositions)] }
}
